"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.VideoPopinEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var field_groups_1 = require("../../field-groups");
var popin_factory_1 = require("./popin-factory");
exports.VideoPopinEntity = popin_factory_1.popinFactory(types_1.DocumentType.VIDEO_POPIN, function (prismicDoc, normalizedPopin, logger) {
    var res = utils_1.compact(__assign(__assign({}, normalizedPopin), { video: logger.required(field_groups_1.toVideo(utils_1.unprefix('video', prismicDoc.data), logger)) }));
    return res;
});
//# sourceMappingURL=video-popin.js.map